export const stripHtml = (value = '') => {
  if (!value) return '';

  if (typeof window !== 'undefined' && window.DOMParser) {
    const doc = new window.DOMParser().parseFromString(value, 'text/html');
    return (doc.body.textContent || '').trim();
  }

  return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};

const escapeHtml = (value = '') => value
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/\"/g, '&quot;')
  .replace(/'/g, '&#39;');

export const toRichHtml = (value = '') => {
  if (!value) return '';

  const hasHtmlTag = /<[^>]+>/.test(value);
  if (hasHtmlTag) return value;

  const paragraphs = value
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br />')}</p>`);

  return paragraphs.join('') || `<p>${escapeHtml(value)}</p>`;
};

export const sanitizeNewsHtml = (value = '') => {
  const raw = toRichHtml(value);
  if (!raw) return '';

  if (typeof window === 'undefined' || !window.DOMParser) {
    return raw;
  }

  const doc = new window.DOMParser().parseFromString(raw, 'text/html');

  doc.querySelectorAll('script, style, iframe, object, embed').forEach((node) => node.remove());

  doc.querySelectorAll('*').forEach((element) => {
    [...element.attributes].forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const attributeValue = attribute.value;

      if (name.startsWith('on')) {
        element.removeAttribute(attribute.name);
        return;
      }

      if ((name === 'href' || name === 'src') && /^\s*javascript:/i.test(attributeValue)) {
        element.removeAttribute(attribute.name);
      }
    });
  });

  return doc.body.innerHTML;
};
